import React, { useState } from "react";
import { Modal } from "react-bootstrap";
import Ravi from "../../assets/directors/dir/ravi.webp";
import Subhash from "../../assets/directors/dir/Subhas.webp";
import Sunil from "../../assets/directors/dir/Sunil.webp";
import Kharanshu from "../../assets/directors/dir/Kharanshu.jpg.jpeg";
import Amol from "../../assets/directors/dir/Anmol.jpg.jpeg";
import Seema from "../../assets/directors/dir/Seema.jpg.jpeg";
import Saroj from "../../assets/directors/dir/Saroj.jpg.jpeg";
import VPSinghSir from "../../assets/directors/dir/SinghSir.jpg.jpeg";
import Vinod from "../../assets/directors/dir/Vinod.jpg.jpeg";
import "../about/about.css";
import "../about/abouresponsive.css";
import "../about/awards.css";
const BoardOfDirector = () => {
  const [show, setShow] = useState(false);
  const [selectedDirector, setSelectedDirector] = useState(null);
  const directors = [
    {
      id: 1,
      name: "Late Mr. V P Singh",
      image: VPSinghSir,
      // imageSet: `${Direc3_208w} 208w, ${Direc3_416w} 416w`,
      role: "Co-Founder & Director",
      description:
        "Late Mr. V P Singh was the Co-Founder & Director of IEEL & IDEAS ELECTRICALS & ENGINEERS LIMITED.. His leadership defined the directorial ethos, as he nurtured talent, cultivated a culture of inclusivity, and fostered an environment conducive for innovation and collaboration. He mentored emerging leaders unleashing their potential, and driving sustainable success. Utilizing his work experience, manpower management, passion for the accomplishment of field operations and dedication to work made him a triumphant businessman in this industry.",
    },
    {
      id: 2,
      name: "Mr. Subhash Sarda",
      image: Subhash,
      // imageSet: `${Direc1_208w} 208w, ${Direc1_416w} 416w`,
      role: "Chairman & CEO",
      description:
        "Armed with a strategic mindset, navigates complexities with finesse, devising robust strategies that align with organizational goals and drives sustainable growth. He leverages market insights, harnesses technology, and fosters strategic partnerships to gain a competitive edge in a rapidly evolving landscape. He is a Mechanical Engineer by profession, Energy Auditor, and MBA (Diploma in Advance Management for Senior Management) from XLRI. Overseas power projects are successfully handled under his supervision and expertise. His aspiration is to set the highest benchmark in the EPC sector by working as a team.",
    },
    {
      id: 3,
      name: "Mr. Sunil Gadekar",
      image: Sunil,
      // imageSet: `${Direc2_208w} 208w, ${Direc2_416w} 416w`,
      role: "Managing Director",
      description:
        "He plays a pivotal role in orchestrating seamless coordination and execution. He ensures adherence to quality standards, regulating requirements and contractual obligations as well as monitoring progress, managing resources, and implementing corrective measures to address deviations from the project plan. Utilizing his work experience, technical expertise, passion for the accomplishment of field operations and dedication to work made him a flourishing businessman in this industry. He is an Electrical Engineer by profession and disciplined by nature which adds to his problem-solving skills. His vision is to run the plant/site operation with ease, yielding maximum return output.",
    },
    {
      id: 4,
      name: "Mr. Ravi Singh",
      image: Ravi,
      // imageSet: `${Direc5_208w} 208w, ${Direc5_416w} 416w`,
      role: "Whole Time Director",
      description:
        "Mr. Ravi Virendrapratap Singh has a strong foundation in business management. He has extensive experience in project planning, execution, and overseeing large-scale industrial and infrastructure projects. He has successfully managed cross-functional teams, driven business development initiatives, and built strong client and stakeholder relationships. He has demonstrated expertise in project oversight, business growth within the electrical contracting and engineering sector, and improving operational efficiency to enhance project margins and organizational growth.",
    },
    {
      id: 5,
      name: "Mrs. Saroj Singh",
      image: Saroj,
      // imageSet: `${Direc4_208w} 208w, ${Direc4_416w} 416w`,
      role: "Non-Executive Director",
      description:
        "She oversees budgets, procurement, and facility management, ensuring effective utilization of resources while maintaining quality standards and regulatory compliance. She possesses a deep understanding of administrative practices and industry trends. With a blend of strategic acumen, interpersonal skills, and resilience, she navigates the complexities of administrative management, driving organizational success and facilitating growth in an ever-evolving environment.",
    },
    {
      id: 6,
      name: "Mrs. Seema Patil",
      image: Seema,
      role: "Non-Executive Director",
      description:
        "Seema Patil is founder and director of more than decade old Singapore based Consultancy firm focussed on advising on matters related to Monetary Authority of Singapore. The firm deals with hedge funds, private equity, venture capital, fintechs, wealth manager and trust companies. Seema is lawyer by qualification and MBA from University of Hull, UK as also graduate in economics and specialist diploma in Compliance and fund management/administration. Seema work experience includes law firms and fund managers. Seema is also involved with NGOs and philanthropic work as owner and contributor.Seema brings to table cross border expertise, global commerce, international law, investor relations and management, securities and governance norms and value creation built through cross border dealing with varied clients and varied industry.",
    },
    {
      id: 7,
      name: "Mr. Vinod Nandapurkar",
      image: Vinod,
      // imageSet: `${Direc6_208w} 208w, ${Direc6_416w} 416w`,
      role: "Independent Director",
      description:
        "Mr. Vinod Nandapurkar is a seasoned industry leader with over 35 years of extensive experience in manufacturing, operations, project management, and strategic leadership within globally competitive industrial environments.He has had a distinguished career with Garware Polyester Limited, where he rose from a Trainee Engineer to the position of President before superannuating in 2020. During his tenure, he led key functions including plant engineering, capital projects, manufacturing operations, and cross-functional domains such as strategic sourcing, sales & marketing, and human resources. He played a pivotal role in driving operational excellence, capacity expansion, and long-term business transformation initiatives.Mr. Nandapurkar has been closely associated with senior leadership  contributing to strategic planning, governance practices, and organizational development. His expertise spans corporate governance, risk management, sustainable growth, and operational strategy.As an Independent Director, he brings a balanced, objective, and value-driven perspective to the Board, strengthening oversight and contributing meaningfully to the Company’s long-term vision and governance framework.He holds a Bachelor of Engineering (Electrical Engineering) from Government Engineering College, Sambhajinagar.",
    },
    {
      id: 8,
      name: "Mr. Kharanshu Parikh",
      image: Kharanshu,
      role: "Independent Director",
      description:
        "Kharanshu Parikh is an Investment Advisor and the Co-Founder of Ekvity, a Multi-Family Office Advisor. With years of experience in the world of investments, he has developed a distinctive approach where finance goes beyond numbers — he brings in philosophical and psychological lenses to make investing more relatable, purposeful, and thought-provoking.He believes in sharing what he learns along the way and creating conversations that spark curiosity. His conversations often move beyond technicalities, encouraging people to look at money not just as a financial tool but as a medium to align with values, choices, and life goals.",
    },
    {
      id: 9,
      name: "Mr. Amol Kaulgud",
      image: Amol,
      role: "Independent Director ",
      description:
        "Amol Kaulgud is a Mechanical Engineer by qualification, he has held senior leadership positions with reputed organizations including Aditya Birla Group, Larsen & Toubro Limited, Huhtamaki India, Tech Nova Imaging Systems, Bombay Dyeing, Blue Star Limited, and Voltas Limited. He holds internationally recognized professional certifications in Project Management (PMI, USA), Supply Management (ISM, USA), Supply Chain Management (ITC Geneva and CCI India) and also handled Greenfield Carbon Black Project, brings deep knowledge and operational experience across direct procurement, indirect procurement, MRO purchasing, and CAPEX sourcing categories.Over the course of this distinguished career, has consistently delivered strategic value by strengthening procurement systems, optimizing supply chains, and enabling successful execution of complex industrial and infrastructure projects.Equally recognized as a people-focused leader with a passion for mentoring and capability building.  He is also recognized for his strong leadership, project management, and team-building capabilities. Mr. Ravi Virendrapratap Singh has a strong foundation in business management. He has extensive experience in project planning, execution, and overseeing large-scale industrial and infrastructure projects. He has successfully managed cross-functional teams, driven business development initiatives, and built strong client and stakeholder relationships. He has demonstrated expertise in project oversight, business growth within the electrical contracting and engineering sector, and improving operational efficiency to enhance project margins and organizational growth.",
    },
  ];
  const handleClose = () => setShow(false);
  const handleShow = (director) => {
    setSelectedDirector(director);
    setShow(true);
  };
  return (
    <div className="main-container">
      {/* Hero Section — same structure as Career hero */}
      <section className="Career-hero-section">
        <div className="Career-heading">
          <h2>Board of Directors</h2>
        </div>
      </section>
      <section className="Director-Section" id="directors">
        <div className="container">
          {(() => {
            const rowPattern = [1, 3, 2, 3];
            let idx = 0;
            const rows = [];
            for (const count of rowPattern) {
              if (idx >= directors.length) break;
              rows.push(directors.slice(idx, idx + count));
              idx += count;
            }
            return rows.map((row, rowIndex) => (
              <div
                key={rowIndex}
                className={`row ${row.length !== 3 ? "justify-content-center" : ""}`}
                style={{ alignItems: "flex-start" }}
              >
                {row.map((director) => (
                  <div
                    key={director.id}
                    className="col-lg-3 col-sm-12 mob-view director-item"
                    onClick={() => handleShow(director)}
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "center",
                    }}
                  >
                    <div className="arrow-container">
                      <span className="clickable-arrow">&#8594;</span>
                    </div>
                    <img
                      src={director.image}
                      srcSet={director.imageSet}
                      sizes="(max-width: 768px) 50vw, 208px"
                      className="img-fluid director-img"
                      alt={director.name}
                      loading="lazy"
                      width="208"
                      height="260"
                    />
                    <h3>{director.name}</h3>
                    <p>
                      <span>{director.role}</span>
                    </p>
                  </div>
                ))}
              </div>
            ));
          })()}
        </div>
      </section>

      <Modal
        show={show}
        onHide={handleClose}
        dialogClassName="custom-modal-content"
        centered
      >
        <Modal.Body>
          <button
            type="button"
            className="close close-btn"
            aria-label="Close"
            onClick={handleClose}
          >
            <span aria-hidden="true">&times;</span>
          </button>
          <div className="row">
            <div className="col-md-3">
              <img
                src={selectedDirector?.image}
                className="img-fluid model-img"
                alt={selectedDirector?.name}
              />
            </div>
            <div className="col-md-9">
              <h3 className="popupmodel-heading">{selectedDirector?.name}</h3>
              <p className="popupmodel-role">
                <span>{selectedDirector?.role}</span>
              </p>
              <p className="popupmodel-description">
                {selectedDirector?.description}
              </p>
            </div>
          </div>
        </Modal.Body>
      </Modal>
    </div>
  );
};

export default BoardOfDirector;
